import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'
import { useState } from 'react'
import { Breadcrumbs } from '@/shared/ui/breadcrumbs'
import { ProfileForm } from '@/widgets/profile-form'

// Панель детали грузится на переходе — не тянем её в стартовый бандл.
const ProfileDetail = lazyRouteComponent(() => import('@/widgets/profile-detail'), 'ProfileDetail')

export const Route = createFileRoute('/telephony/profiles/$profileId')({
  component: ProfilePage,
})

function ProfilePage() {
  const { profileId } = Route.useParams()
  const [editOpen, setEditOpen] = useState(false)

  return (
    <>
      <Breadcrumbs current={profileId} />
      <ProfileDetail profileId={profileId} onEdit={() => setEditOpen(true)} />
      <ProfileForm
        key={profileId}
        open={editOpen}
        profileId={profileId}
        onClose={() => setEditOpen(false)}
      />
    </>
  )
}
